import { ReactNotifications } from 'react-notifications-component';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import Routes from './Routes';
import 'react-notifications-component/dist/theme.css';
import MSALProvider from './authentication-context/msalProvider';
import { isAzureMfaEnabled } from './config/env';

const Root = ({ store, history }) =>
  isAzureMfaEnabled?.toLowerCase() === 'true' ? (
    <Provider store={store}>
      <Router history={history}>
        <MSALProvider>
          <ReactNotifications />
          <Routes />
        </MSALProvider>
      </Router>
    </Provider>
  ) : (
    <Provider store={store}>
      <Router history={history}>
        <ReactNotifications />
        <Routes />
      </Router>
    </Provider>
  );

export default Root;
